import React from "react";
import Wishlist from "../components/Wishlist";

const WishlistPage = () => {
  return (
    <>
      <Wishlist />
    </>
  );
};

export default WishlistPage;
